<template>
<div>
  <el-form
    label-position="right"
    label-width="90px"
  >
    <el-form-item label="通知内容">
      <el-input v-model="currentPlugin.text" placeholder="请输入通知内容"  clearable/>
    </el-form-item>

    <el-form-item label="属性">
        <el-checkbox v-model="currentPlugin.wrapable" label="多行显示"  />
        <el-checkbox v-model="currentPlugin.scrollable" label="滚动播放" />
    </el-form-item>
  
    <el-form-item label="滚动速率" v-if="currentPlugin.scrollable">
      <el-input-number size="small" v-model="currentPlugin.speed" :min="20" :max="150"></el-input-number>
    </el-form-item>

    <el-divider>其他</el-divider>


    <el-form-item label="字体色">
      <el-color-picker v-model="currentPlugin.color" color-format="hex" size="small"></el-color-picker>
    </el-form-item>
    <el-form-item label="背景色" v-if="!currentPlugin.transparent">
      <el-color-picker v-model="currentPlugin.bgColor" color-format="hex" size="small"></el-color-picker>
    </el-form-item>
  
    <el-form-item label="点击图标">
      <el-radio-group v-model="currentPlugin.handle" size="small">
        <el-radio-button label="none">默认</el-radio-button>
        <el-radio-button label="link">跳转</el-radio-button>
        <el-radio-button label="message">消息</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <div class="set-options"  v-if="currentPlugin.handle =='link' || currentPlugin.handle =='message'">
      <!-- message -->
      <el-form-item label="弹出消息" v-if="currentPlugin.handle=='message'">
        <el-input v-model="currentPlugin.message" placeholder="如：请联系客服制作同款页面"/>
      </el-form-item>
      <!-- link -->
      <template v-if="currentPlugin.handle=='link'">
        <p class="help">H5打开：跳转网址</p>
        <el-form-item label="网址">
          <el-input v-model="currentPlugin.link" placeholder="如：https://www.2weima.com">
            <el-button slot="append" @click="onActionLink">选择</el-button>
          </el-input>
        </el-form-item>
          <p class="help">小程序打开：跳转页面，支持第三方小程序</p>
        <el-form-item label="小程序页面">
          <el-input v-model="currentPlugin.path" placeholder="如：pages/index/index?foo=bar">
            <el-button slot="append" @click="onActionLink">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="小程序appId">
          <el-input v-model="currentPlugin.appId" placeholder="如：wx81bdf0b17a44370d"/>
        </el-form-item>
      </template>
    </div>

    <el-divider>提示</el-divider>
    <div class="help mt-10">滚动播放时字体色修改不会马上显示，可先取消滚动</div>

  </el-form>
  <!-- 链接选择 -->
  <action-link-dialog :visible.sync="visibleLink" source="diy" :showAll="true" @confirm="onConfirmLink"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import ActionLinkDialog from '../../ActionLinkDialog'

export default {
  name: 'noticeBar',
  props: {},
  components: {
    ActionLinkDialog,
  },
  computed:{
    ...mapGetters(['currentPlugin'])
  },
  data:function(){
    return {
      visibleLink:false,
    }
  },
  methods:{
    onActionLink(){
      // console.log('onUploadImage')
      this.visibleLink = true;
    },
    onConfirmLink(linkData){
      // console.log('linkData',linkData)
      this.currentPlugin.link = linkData.qrview;
      this.currentPlugin.path = linkData.weapp_path;
      this.currentPlugin.appId = linkData.weapp_id;
    },
   
  }
}

</script>


<style scoped>


</style>
